(function () {
    'use strict';

    function addWorkflowInformationPart() {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/addWorkflowInformationPart.html',
            scope: {
                informationParts: '=',
                informationPartType: '@',
                isActive: '=',
                addInformationPart: '&',
                stateUpdatedEventName: '@'
            },
            link: function (scope, element, attrs) {
                scope.model = {
                    titleAndPrompt: ''
                };

                function updateSiblingNames() {
                    scope.siblingNames = scope.informationParts.filter(function (part) { return !part.IsRemoved; })
                        .map(function (part) { return part.Title; });
                }

                updateSiblingNames();

                $(element).find('input').on('blur', function () {
                    scope.addPhaseInformationPartForm.$setUntouched();
                });

                scope.placeholder = scope.informationPartType == 'Document' ? 'Add Document' : 'Add Question Set';
                scope.addDocument = function () {
                    var titleAndPrompt = scope.model.titleAndPrompt;

                    scope.addInformationPart({
                        informationPart: {
                            $type:
                                "Ecap.Api.ViewModels.DocumentViewModel, Ecap.Api",
                            Title: titleAndPrompt,
                            Prompt: titleAndPrompt,
                            BlobSummaries: []
                        }
                    });
                    scope.close();
                }

                scope.addQuestionSet = function () {
                    var titleAndPrompt = scope.model.titleAndPrompt;
                    scope.addInformationPart({
                        informationPart: {
                            $type:
                                "Ecap.Api.ViewModels.QuestionSetViewModel, Ecap.Api",
                            Title: titleAndPrompt,
                            Prompt: titleAndPrompt,
                            Questions: []
                        }
                    });
                    scope.close();
                }

                scope.close = function () {
                    scope.isActive = !scope.isActive;
                    scope.model.titleAndPrompt = '';
                }

                scope.modelChange = function () {
                    if (scope.model.titleAndPrompt.length === 0) {
                        scope.addPhaseInformationPartForm.$setUntouched();
                    }
                }

                scope.$on(scope.stateUpdatedEventName, function () {
                    updateSiblingNames();
                });
            }
        };
    }

    addWorkflowInformationPart.$inject = ['workflowStateService'];

    angular.module('ecap.workflow').directive('addWorkflowInformationPart', addWorkflowInformationPart);
})();

